export const useScript = (flag: string, content: string, target: string = 'body', async: boolean = false, callback?: () => void): void => {
  const script = document.createElement('script') as HTMLScriptElement;
  script.async = async;
  script[flag] = content;
  script.onload = (): void => {
    if (callback && typeof callback === 'function') {
      callback();
    }
  };
  document?.[target].appendChild(script);
};
